import React from 'react';

export const AddLabel = (): JSX.Element => {
  return (
    <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5.26172" y="1" width="24" height="16" rx="3.5" fill="transparent" stroke="#ffffff" />
      <circle cx="6.35664" cy="15.393" r="6.35664" fill="#ffffff" />
      <path d="M8.47604 15.393H4.23828" stroke="#E5145B" strokeWidth="2" strokeLinecap="square" />
      <path d="M6.35737 17.5119V13.2742" stroke="#E5145B" strokeWidth="2" strokeLinecap="square" />
    </svg>
  );
};

export const HideLabel = (): JSX.Element => {
  return (
    <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.07812" y="3.49207" width="24" height="16" rx="3.5" fill="transparent" stroke="#ffffff" />
      <rect
        width="3"
        height="30"
        transform="matrix(-0.731354 0.681998 0.681998 0.731354 2.95703 0.265259)"
        fill="#ffffff"
      />
    </svg>
  );
};

export const Highlight = (): JSX.Element => {
  return (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0957 2.92246L14.3484 6.34598L15.9357 4.6753C16.274 4.31925 16.274 3.7441 15.9357 3.38806L13.906 1.25178C13.5677 0.89573 13.0213 0.89573 12.683 1.25178L11.0957 2.92246ZM10.1676 3.89951L13.4203 7.32304L5.56174 15.5943H2.30902V12.1707L10.1676 3.89951ZM17.922 21.0717H0.574219V17.4199H17.922V21.0717Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const HideHighlights = (): JSX.Element => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0957 4.76437L18.3484 8.1879L19.9357 6.51722C20.274 6.16117 20.274 5.58602 19.9357 5.22997L17.906 3.0937C17.5677 2.73765 17.0213 2.73765 16.683 3.0937L15.0957 4.76437ZM14.1676 5.74143L17.4203 9.16496L9.56174 17.4362H6.30902V14.0127L14.1676 5.74143ZM21.922 22.9136H4.57422V19.2619H21.922V22.9136Z"
        fill="#ffffff"
      />
      <rect
        width="3"
        height="30"
        transform="matrix(-0.731354 0.681998 0.681998 0.731354 3.03125 0.390381)"
        fill="#ffffff"
      />
    </svg>
  );
};

export const AddNote = ({ color }: { color: string }): JSX.Element => {
  return (
    <svg width="31" height="29" viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6006 4H25.3889C26.55 4 27.5 4.95 27.5 6.11111V16.6667L21.1667 23H10.6111C9.45 23 8.51056 22.05 8.51056 20.8889L8.5 6.11111C8.5 4.95 9.43944 4 10.6006 4ZM23.2782 9.27734H12.7227V11.3885H23.2782V9.27734ZM18.0004 15.6111H12.7227V13.5H18.0004V15.6111ZM20.1094 15.6113V21.4169L25.9149 15.6113H20.1094Z"
        fill="#ffffff"
      />
      <circle cx="6.67696" cy="22.1604" r="6.35664" fill="#ffffff" />
      <path d="M8.79636 22.1611H4.55859" stroke={color} strokeWidth="2" strokeLinecap="square" />
      <path d="M6.67768 24.2798V20.042" stroke={color} strokeWidth="2" strokeLinecap="square" />
    </svg>
  );
};

export const HideNotes = (): JSX.Element => {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.603 4.11719H20.3913C21.5524 4.11719 22.5024 5.06719 22.5024 6.2283V16.7839L16.1691 23.1172H5.61355C4.45244 23.1172 3.513 22.1672 3.513 21.0061L3.50244 6.2283C3.50244 5.06719 4.44189 4.11719 5.603 4.11719ZM18.2807 9.39551H7.7251V11.5066H18.2807V9.39551ZM13.0029 15.7283H7.7251V13.6172H13.0029V15.7283ZM15.1118 15.7285V21.5341L20.9174 15.7285H15.1118Z"
        fill="#ffffff"
      />
      <rect
        width="3"
        height="30"
        transform="matrix(-0.731354 0.681998 0.681998 0.731354 2.64307 1.39062)"
        fill="#ffffff"
      />
    </svg>
  );
};

export const ShowNotes = (): JSX.Element => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.60251 0.117188H17.3908C18.552 0.117188 19.502 1.06719 19.502 2.2283V12.7839L13.1686 19.1172H2.61306C1.45195 19.1172 0.512509 18.1672 0.512509 17.0061L0.501953 2.2283C0.501953 1.06719 1.4414 0.117188 2.60251 0.117188ZM15.2802 5.39551H4.72461V7.50662H15.2802V5.39551ZM10.0024 11.7283H4.72461V9.61719H10.0024V11.7283ZM12.1113 11.7285V17.5341L17.9169 11.7285H12.1113Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const Draw = (): JSX.Element => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 11.2578C3 12.3178 3.61 13.0478 4.58 13.6078L6.07 12.1178C5.43 11.8578 5 11.5678 5 11.2578C5 10.7578 6.42 10.1378 7.36 9.72781C9.07 8.97781 11 8.12781 11 6.25781C11 4.57781 9.24 3.25781 7 3.25781C4.76 3.25781 3.73 4.49781 3.62 4.63781C3.28 5.06781 3.36 5.67781 3.77 6.01781C4.19 6.35781 4.82 6.30781 5.17 5.89781C5.17096 5.89685 5.17245 5.89529 5.17447 5.89317C5.23542 5.82927 5.78046 5.25781 7 5.25781C8.22 5.25781 9 5.84781 9 6.25781C9 6.80848 7.63659 7.41717 6.61179 7.87469C6.59443 7.88244 6.57716 7.89015 6.56 7.89781C4.89 8.62781 3 9.45781 3 11.2578ZM18.8498 10.6479L19.9098 9.58792C20.6898 8.80792 20.6898 7.53792 19.9098 6.75792L18.4998 5.34792C17.7198 4.56792 16.4498 4.56792 15.6698 5.34792L14.6098 6.40792L18.8498 10.6479ZM14.61 12.0678L7.41 19.2578H6V17.8478L13.19 10.6578L14.61 12.0678ZM4 17.0178L13.19 7.81781L17.43 12.0678L8.24 21.2578H4V17.0178ZM19 17.7578C19 19.9478 16.46 21.2578 14 21.2578C13.45 21.2578 13 20.8078 13 20.2578C13 19.7078 13.45 19.2578 14 19.2578C15.54 19.2578 17 18.5278 17 17.7578C17 17.2878 16.52 16.8878 15.77 16.5578L17.25 15.0778C18.32 15.7078 19 16.5478 19 17.7578Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const HideDrawings = (): JSX.Element => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.05371 11.2617C3.05371 12.3217 3.66371 13.0517 4.63371 13.6117L6.12371 12.1217C5.48371 11.8617 5.05371 11.5717 5.05371 11.2617C5.05371 10.7617 6.47371 10.1417 7.41371 9.73172C9.12371 8.98172 11.0537 8.13172 11.0537 6.26172C11.0537 4.58172 9.29371 3.26172 7.05371 3.26172C4.81371 3.26172 3.78371 4.50172 3.67371 4.64172C3.33371 5.07172 3.41371 5.68172 3.82371 6.02172C4.24371 6.36172 4.87371 6.31172 5.22371 5.90172C5.22467 5.90076 5.22616 5.89919 5.22819 5.89707C5.28913 5.83317 5.83417 5.26172 7.05371 5.26172C8.27371 5.26172 9.05371 5.85172 9.05371 6.26172C9.05371 6.81239 7.69031 7.42107 6.6655 7.87859C6.64814 7.88635 6.63087 7.89405 6.61371 7.90172C4.94371 8.63172 3.05371 9.46172 3.05371 11.2617ZM18.9035 10.6518L19.9635 9.59182C20.7435 8.81182 20.7435 7.54182 19.9635 6.76182L18.5535 5.35182C17.7735 4.57182 16.5035 4.57182 15.7235 5.35182L14.6635 6.41182L18.9035 10.6518ZM14.6637 12.0717L7.46371 19.2617H6.05371V17.8517L13.2437 10.6617L14.6637 12.0717ZM4.05371 17.0217L13.2437 7.82172L17.4837 12.0717L8.29371 21.2617H4.05371V17.0217ZM19.0537 17.7617C19.0537 19.9517 16.5137 21.2617 14.0537 21.2617C13.5037 21.2617 13.0537 20.8117 13.0537 20.2617C13.0537 19.7117 13.5037 19.2617 14.0537 19.2617C15.5937 19.2617 17.0537 18.5317 17.0537 17.7617C17.0537 17.2917 16.5737 16.8917 15.8237 16.5617L17.3037 15.0817C18.3737 15.7117 19.0537 16.5517 19.0537 17.7617Z"
        fill="#ffffff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.19434 0.535156L0.000274837 2.58115L10.4921 13.8323L20.4602 24.5218L22.6543 22.4758L2.19434 0.535156Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const ImageEditor = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 17" fill="none">
      <g clipPath="url(#a)">
        <mask id="b" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="17">
          <path
            d="M16.364 0H1.636C.818 0 0 .895 0 1.79v12.526c0 .984.736 1.79 1.636 1.79h14.728c.818 0 1.636-.896 1.636-1.79V1.789C18 .895 17.182 0 16.364 0zM3.788 11.802l2.037-2.864c.164-.223.475-.232.639-.009l1.718 2.264 2.536-3.57a.39.39 0 0 1 .655.01l2.872 4.186c.204.296.008.716-.328.716h-9.81c-.335-.009-.532-.438-.319-.733z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="M16.364 0H1.636C.818 0 0 .895 0 1.79v12.526c0 .984.736 1.79 1.636 1.79h14.728c.818 0 1.636-.896 1.636-1.79V1.789C18 .895 17.182 0 16.364 0zM3.788 11.802l2.037-2.864c.164-.223.475-.232.639-.009l1.718 2.264 2.536-3.57a.39.39 0 0 1 .655.01l2.872 4.186c.204.296.008.716-.328.716h-9.81c-.335-.009-.532-.438-.319-.733z"
            fill="#ffffff"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v16.105H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Undo = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 17 17">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M0 0L17 0 17 17 0 17z"
              transform="translate(-99.000000, -657.000000) translate(99.000000, 657.000000)"
            />
            <path
              fill="#ffffff"
              fillRule="nonzero"
              d="M8.854 5.667c-1.877 0-3.577.7-4.887 1.841l-2.55-2.55v6.375h6.375L5.228 8.77c.984-.822 2.238-1.332 3.626-1.332 2.508 0 4.64 1.637 5.384 3.896l1.678-.552c-.984-2.968-3.768-5.114-7.062-5.114z"
              transform="translate(-99.000000, -657.000000) translate(99.000000, 657.000000)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Redo = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 17 17">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M0 0L17 0 17 17 0 17z"
              transform="translate(-99.000000, -682.000000) translate(99.000000, 682.000000)"
            />
            <path
              fill="#ffffff"
              fillRule="nonzero"
              d="M13.033 7.508c-1.31-1.14-3.01-1.841-4.887-1.841-3.294 0-6.078 2.146-7.055 5.114l1.672.552c.743-2.26 2.868-3.896 5.383-3.896 1.381 0 2.642.51 3.627 1.332l-2.565 2.564h6.375V4.958l-2.55 2.55z"
              transform="translate(-99.000000, -682.000000) translate(99.000000, 682.000000)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Reset = (): JSX.Element => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.1297 3.54858C17.4741 2.77254 16.7011 2.09668 15.8339 1.5473C14.2362 0.53506 12.3877 0 10.4883 0C7.81721 0 5.30597 1.04018 3.41722 2.92893C1.52846 4.81768 0.488281 7.32891 0.488281 9.99998C0.488281 12.671 1.52846 15.1824 3.41722 17.0711C5.30597 18.9598 7.81721 20 10.4883 20C12.5406 20 14.513 19.3826 16.1924 18.2146C17.832 17.074 19.0816 15.4912 19.8058 13.6374L17.5321 12.7491C16.3908 15.6709 13.6258 17.5589 10.4882 17.5589C6.32018 17.5589 2.92921 14.168 2.92921 9.99989C2.92921 5.8318 6.32023 2.44092 10.4883 2.44092C12.598 2.44092 14.5489 3.29809 15.9501 4.7674L13.2932 6.25325L16.7583 8.31754L20.2235 10.382L20.2786 6.34892L20.3339 2.31587L18.1297 3.54858Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const HideText = (): JSX.Element => {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50293 8.11719V5.11719H16.5029V8.11719H11.5029V20.1172H8.50293V8.11719H3.50293ZM13.5029 10.1172H22.5029V13.1172H19.5029V20.1172H16.5029V13.1172H13.5029V10.1172Z"
        fill="#ffffff"
      />
      <rect
        width="3"
        height="30"
        transform="matrix(-0.731354 0.681998 0.681998 0.731354 3.14355 1.39062)"
        fill="#ffffff"
      />
    </svg>
  );
};

export const ShowHiddenText = (): JSX.Element => {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.503906 3.11719V0.117188H13.5039V3.11719H8.50391V15.1172H5.50391V3.11719H0.503906ZM10.5039 5.11719H19.5039V8.11719H16.5039V15.1172H13.5039V8.11719H10.5039V5.11719Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const AddPicture = ({ color }: { color: string }): JSX.Element => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.313 9.474v5.665s-3.77.019-3.79 0V9.474H20.84s.018-3.77 0-3.79h5.684V0h3.79v5.684h5.683v3.79h-5.684zm-5.68 7.578v-5.684h-5.685V5.684H3.79A3.8 3.8 0 0 0 0 9.474V32.21A3.8 3.8 0 0 0 3.79 36h22.737a3.8 3.8 0 0 0 3.79-3.79V17.052h-5.685zm-15.16 7.58L3.789 32.21h22.737l-7.58-9.474-5.684 7.579-3.79-5.684z"
        fill={`${color}`}
      />
    </svg>
  );
};

export const Save = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 17 17" fill="none">
      <path
        d="M13.78.557A1.894 1.894 0 0 0 12.437 0H1.888C.842 0 0 .85 0 1.889V15.11C0 16.15.85 17 1.889 17H15.11C16.15 17 17 16.15 17 15.111V4.561c0-.5-.198-.982-.557-1.331L13.779.557zM8.5 15.111a2.83 2.83 0 0 1-2.833-2.833A2.83 2.83 0 0 1 8.5 9.444a2.83 2.83 0 0 1 2.833 2.834A2.83 2.83 0 0 1 8.5 15.11zm.944-9.444H3.778a1.894 1.894 0 0 1-1.89-1.89c0-1.038.85-1.888 1.89-1.888h5.666c1.04 0 1.89.85 1.89 1.889 0 1.039-.85 1.889-1.89 1.889z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const Close = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M0 0L24 0 24 24 0 24z"
              transform="translate(-93.000000, -123.000000) translate(93.000000, 123.000000)"
            />
            <path
              fill="#ffffff"
              fillRule="nonzero"
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              transform="translate(-93.000000, -123.000000) translate(93.000000, 123.000000)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EditText = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 17 17" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m15.645 3.831-2.394-2.446L14.42.19a.626.626 0 0 1 .9 0l1.494 1.526a.66.66 0 0 1 0 .92l-1.168 1.194zm-3.077-1.748 2.394 2.446L9.18 10.44H6.785V7.994l5.783-5.911zm-11.255-.07H0V17h13.569V10.066h-2.626v4.25H2.626V4.697h6.347V2.013h-7.66z"
        fill="#ffffff"
      />
    </svg>
  );
};
